import { ApiService } from '../../app-lite/api/api.service';

import LaborItemsHtml from './labor-items.html'

export function LaborItemsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller: 'laborItemsCtrl',
    name      : 'app.labor-items',
    params    : {
      invoice_item_id: { squash: true, value: null }
    },
    templateUrl: LaborItemsHtml,
    url        : '/:invoice_id/:invoice_item_id/labor_items',
    resolve    : {
      invoice     : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/invoice', $stateParams.invoice_id),
      invoice_item: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | object => $stateParams.invoice_item_id
        ? workshopAPI.get('/invoice_item', $stateParams.invoice_item_id)
        : { labor_items_attributes: [] }
    }
  });
}
